<template>
    <div>
        <Header :perks="perks"/>
<!--        <BreadCrumb :laptop="laptop"/>-->
        <div v-if="Object.keys(laptop).length">
            <div class="container">
                <div class="columns">
                    <div class="column is-5">
                        <div class="images clearfix">
                            <viewer :images="laptop.images" :movable="true">
                                <img v-for="src in laptop.images" :key="src.url" :src="MEDIA_URL + src.url"
                                     class="image">
                            </viewer>
                        </div>
                    </div>
                    <div class="column">
                        <aside class="menu">
                            <div class="columns">
                                <div class="column">
                                    <h1 class="title">
                                        <!--                                {{laptop.brand.name}}-->
                                        {{laptop.name}}
                                    </h1>
                                    <p class="menu-label">
                                        Описание продукта:
                                    </p>
                                    <ul class="menu-list">
                                        <li><a>Состояние: Новое</a></li>
                                        <li>
                                            <router-link :to="'/' + laptop.brand.slug+ '-produkti'">
                                                Бренд: {{ laptop.brand.name }}
                                            </router-link>
<!--                                            <router-link-->
<!--                                                    :to="'/categories/' + laptop.category.slug + '-' + laptop.category.id">-->
<!--                                                Бренд: {{laptop.brand.name }}-->
<!--                                            </router-link>-->
                                        </li>
                                        <li>
                                            <router-link
                                                    :to="'/categories/' + laptop.category.slug + '-' + laptop.category.id">
                                                Категория: {{laptop.category.name }}
                                            </router-link>
                                        </li>
                                        <li><a>Гарантия: 12 месяцев с момента покупки от официального сервисного Центра
                                            {{ laptop.brand.name }}</a></li>
                                        <li v-if="laptop.perks">
                                            <a>Особенности:
                                                <span class="tag is-warning" v-for="perk in laptop.perks"
                                                      :key="perk.id">
                                                        {{ perk.name }} <br/>
                                                    </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="column is-one-third">
                                    <aside class="menu">
                                        <p class="menu-label">
                                            ЦЕНА
                                        </p>
                                        <ul class="menu-list">
                                            <li v-if="laptop.old_price_uzs > 0"><a style="font-size:22px;"><s>{{ formatPrice(laptop.old_price_uzs) }} Сум</s></a></li>
                                        </ul>
                                        <ul class="menu-list">
                                            <li>
                                                <a class="is-active" style="font-size:22px;">{{ formatPrice(laptop.price_uzs)}} Сум</a>
                                            </li>
                                            <li>
                                                <div v-if="laptop.price_uzs > 500000">
                                                    <a v-if="laptop.vat"><b>{{formatPrice(laptop.price_uzs*1.38/12)}}</b> сум / месяц<br />(Рассрочка 12 месяцев)</a>
                                                    <a v-else><b>{{formatPrice(laptop.price_uzs*1.38*1.15/12)}}</b> сум / месяц<br />(Рассрочка 12 месяцев)</a>
                                                </div>
                                            </li>
                                        </ul>
                                    </aside>
                                    <p class="menu-label">
                                        Методы Оплаты:
                                    </p>
                                    <p>
                                        <b-icon pack="fas" icon="check" size="is-small" type="is-primary"></b-icon>
                                        <span> Наличными</span>
                                    </p>
                                    <p>
                                        <b-icon pack="fas" icon="check" size="is-small" type="is-primary"></b-icon>
                                        <span> Терминалом</span>
                                    </p>
                                    <p>
                                        <b-icon pack="fas" icon="check" size="is-small" type="is-primary"></b-icon>
                                        <span> Payme / Click</span>
                                    </p>
                                    <p v-if="laptop.vat">
                                        <b-icon pack="fas" icon="check" size="is-small" type="is-primary"></b-icon>
                                        <span> Перечислением с НДС</span>
                                    </p>
                                    <p>
                                        <b-icon pack="fas" icon="check" size="is-small" type="is-primary"></b-icon>
                                        <span> При Доставке</span>
                                    </p>
                                    <br/>
<!--                                    <div v-if="inventory_count">-->
<!--                                        <div v-if="inventory_count > 0">-->
                                    <div>
                                        <div>
                                            <p>
                                                <b-icon pack="fas" icon="check" size="is-small"
                                                        type="is-success"></b-icon>
                                                <span> Есть в наличии</span>
                                            </p>
                                            <p>
                                                <button v-if="!ordered"
                                                        class="button is-primary is-large has-text-weight-semibold"
                                                        @click="isOrderModalActive = true">
                                                    Хочу Купить
                                                </button>
                                            </p>
                                        </div>
                                    </div>
                                    Есть вопросы?<br/>
                                    <a class="navbar-item" href="tel: +998 98 128 58 72">
                                        <img src="../../../assets/images/social/phone.png" width="16">
                                        <span class=" has-text-weight-bold"> +998 98 128 58 72</span>
                                    </a>
                                    <a class="navbar-item" href="https://telegram.me/ultrashopuz" target="_blank">
                                        <img src="../../../assets/images/social/telegram.png" width="16">
                                        <span class=" has-text-weight-bold"> @ultrashopuz</span>
                                    </a>
                                    <p>
                                        <img src="../../../assets/images/free_delivery.png" width="322" height="98"/>
                                    </p>
                                </div>
                            </div>
                            <b-modal
                                    :active.sync="isOrderModalActive"
                                    :width="640"
                                    scroll="keep"
                            >
                                <div class="card">
                                    <div class="card-content">
                                        <div class="content">
                                            <form @keyup.13="postInquiry" class="has-text-warning">
                                                <h1 class="subtitle">Заполните эту простую форму и мы с вами свяжемся с
                                                    вами в течении 10 минут обсудить детали</h1>

                                                <b-field label="Ваше Имя" type="is-primary">
                                                    <b-input placeholder="Введите ваше имя сюда"
                                                             v-model="personal_data.name"
                                                             ref="name"
                                                             autofocus required></b-input>
                                                </b-field>
                                                <b-field grouped>
                                                    <b-field label="Номер для связи" type="is-success" expanded>
                                                        <b-input type="number" v-model="personal_data.phone"
                                                                 placeholder="К примеру: 90 911 22 44" required></b-input>
                                                    </b-field>
                                                </b-field>
                                                <button class="button is-primary is-pulled-right" @click="postInquiry">
                                                    Отправить
                                                    заявку
                                                </button>
                                                <button class="button is-danger is-inverted is-pulled-right"
                                                        @click="isOrderModalActive = false">Отменить
                                                </button>
                                                &nbsp;
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </b-modal>
                        </aside>
                    </div>
                </div>
            </div>
        </div>
        <section class="section">
            <div class="container">
                <p class="title">Описание {{laptop.name}}</p>
                <ul>
                    <li><span v-html="laptop.description"></span></li>
                </ul>
            </div>
        </section>
    </div>
</template>
<script>
    import TopBar from '../../components/header/TopBar'
    import Header from "../../components/header/Header2";
    import axios from 'axios'
    // import BreadCrumb from "../../components/BreadCrumb";
    import Viewer from 'v-viewer/src/component'
    import {Carousel, Slide} from 'vue-carousel'
    import 'viewerjs/dist/viewer.css'
    import {API_URL} from '../../../main.js'
    import ProductCard from "../../components/products/ProductCard2";

    export default {
        name: 'ProductDetails2',
        components: {ProductCard, Header, Viewer, Carousel, Slide, TopBar},
        props: {
            slug: {},
            product_id: {},
            type: {},
            category_id: {}
        },
        inject: ['formatPrice', 'toastWarning', 'openLoading', 'closeLoading'],
        data() {
            return {
                personal_data: {
                    // name: localStorage.getItem('personal_data_name'),
                    // phone: localStorage.getItem('personal_data_phone')
                    name: '',
                    phone: ''
                },
                inventory_count: Number,
                showForm: false,
                ordered: false,
                index: null,
                laptop: {},
                ddr: 3,
                model: '',
                secondary_storage: '',
                relatedLaptops: '',
                related_count: 0,
                dollar_rate: Number,
                isOrderModalActive: false,
                API_URL: process.env.VUE_APP_API_URL,
                MEDIA_URL: process.env.VUE_APP_MEDIA_URL,
                processor_type: '',
                perks: [],
            }
        },
        methods: {
            fetchPerks() {
                axios.get(this.API_URL + '/products/perks')
                    .then(response => {
                        this.perks = response.data
                    })
            },
            fetchDollarRate() {
                axios.get(this.API_URL + '/dollar')
                    .then(response => {
                        this.dollar_rate = response.data[0].exchange_rate
                    })
            },
            fetchProduct() {
                this.openLoading()
                axios.get(API_URL + '/products/', {
                    params: {
                        id: this.product_id,
                        slug: this.slug,
                        category: this.category_id
                    }
                })
                    .then(response => {
                        this.laptop = response.data.results[0];
                        this.fetchDollarRate()

                        this.closeLoading()
                        if (this.laptop === undefined) {
                            this.$router.push('/404')
                        }
                    })
                // .then(this.fetchRelatedLaptops)
            },
            // fetchRelatedLaptops() {
            //     axios.get(API_URL + '/products?limit=20&available=true', {
            //         params: {
            //             type: this.laptop.laptop_type.id,
            //             id_not: this.id
            //         }
            //     })
            //         .then(response => {
            //             this.relatedLaptops = response.data.results
            //             this.related_count = response.data.count
            //         })
            // },
            postInquiry() {
                this.openLoading()
                axios.post(API_URL + '/inquiries/createproduct', {
                    name: this.personal_data.name,
                    phone: this.personal_data.phone,
                    product: this.product_id,
                    source: 'Details Page'
                })
                    .then(() => {
                        this.closeLoading()
                        this.ordered = !this.ordered;
                        this.isOrderModalActive = false
                        this.toastWarning(
                            'Ваша заявка получена! Ждите наш звонок. Спасибо', 'is-top', 'is-success'
                        )
                    });
                // localStorage.setItem('personal_data_name', this.personal_data.name);
                // localStorage.setItem('personal_data_phone', this.personal_data.phone)
            },
        },
        beforeRouteUpdate(to, from, next) {
            // this.brand = to.params.brand
            this.slug = to.params.slug
            this.id = to.params.id
            this.category_id = to.params.category_id
            // this.inventory_count = to.params.inventory_count
            this.fetchProduct()
            // this.fetchInventory()
            next()
        },
        created() {
            this.fetchProduct()
            this.fetchPerks()
        }
    }
</script>
<style scoped>
    .tag {
        margin: 2px;
    }

    .image {
        width: calc(20% - -85px);
        cursor: pointer;
        margin: 5px;
        display: inline-block;
    }

    .test-enter-active, .test-leave-active {
        transition: opacity .8s linear;
    }

    .test-enter, .test-leave-to /* .test-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .content h1 {
        font-size: 1.25em;
    }

    .line-through {
        position: relative;
    }

    .line-through:before {
        position: absolute;
        content: "";
        left: 0;
        top: 50%;
        right: 0;
        border-top: 1px solid;
        border-color: inherit;
        color: red;
        -webkit-transform: rotate(-7deg);
        -moz-transform: rotate(-7deg);
        -ms-transform: rotate(-7deg);
        -o-transform: rotate(-7deg);
        transform: rotate(-7deg);
    }
</style>
